import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../components/AppIcon';

const PrivacyPolicyPage = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center space-x-3">
              <Icon name="ArrowLeft" size={24} className="text-gray-600" />
              <span className="font-poppins font-heading-semibold text-lg text-gray-900">
                Geri Dön
              </span>
            </Link>
            <h1 className="font-poppins font-heading-bold text-2xl text-gray-900">
              Gizlilik Politikası
            </h1>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="prose prose-lg max-w-none">
          <div className="mb-8">
            <p className="text-gray-600">
              <strong>Son Güncelleme:</strong> 15 Ocak 2024
            </p>
          </div>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              1. Giriş
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Cafe Otomasyonu olarak, kişisel verilerinizin güvenliği bizim için son derece önemlidir. 
              Bu Gizlilik Politikası, hizmetlerimizi kullanırken topladığımız, kullandığımız ve koruduğumuz 
              bilgiler hakkında sizi bilgilendirmek amacıyla hazırlanmıştır.
            </p>
            <p className="text-gray-700 leading-relaxed">
              Bu politika, https://cafeotomasyonu.com web sitesi ve Cafe Otomasyonu mobil uygulamaları 
              aracılığıyla sunduğumuz tüm hizmetler için geçerlidir.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              2. Topladığımız Bilgiler
            </h2>
            
            <h3 className="font-poppins font-heading-semibold text-xl text-gray-800 mb-3">
              2.1 Kişisel Bilgiler
            </h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Ad, soyad ve iletişim bilgileri</li>
              <li>İşletme adı ve adresi</li>
              <li>Telefon numarası ve e-posta adresi</li>
              <li>Ödeme bilgileri (güvenli şekilde şifrelenmiş)</li>
              <li>Kullanıcı adı ve şifre</li>
            </ul>

            <h3 className="font-poppins font-heading-semibold text-xl text-gray-800 mb-3">
              2.2 İşletme Bilgileri
            </h3>
            <ul className="list-disc pl-6 text-gray-700 mb-4">
              <li>Menü ve ürün bilgileri</li>
              <li>Sipariş ve satış verileri</li>
              <li>Müşteri bilgileri (sadece sipariş amaçlı)</li>
              <li>Stok ve envanter bilgileri</li>
              <li>Personel bilgileri</li>
            </ul>

            <h3 className="font-poppins font-heading-semibold text-xl text-gray-800 mb-3">
              2.3 Teknik Bilgiler
            </h3>
            <ul className="list-disc pl-6 text-gray-700">
              <li>IP adresi ve cihaz bilgileri</li>
              <li>Tarayıcı türü ve işletim sistemi</li>
              <li>Kullanım istatistikleri ve analitik veriler</li>
              <li>Çerezler ve benzer teknolojiler</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              3. Bilgilerin Kullanım Amacı
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Topladığımız bilgileri aşağıdaki amaçlarla kullanırız:
            </p>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Hizmetlerimizi sağlamak ve iyileştirmek</li>
              <li>Müşteri desteği ve iletişim</li>
              <li>Güvenlik ve dolandırıcılık önleme</li>
              <li>Yasal yükümlülükleri yerine getirme</li>
              <li>Pazarlama ve promosyon (izin verilmesi durumunda)</li>
              <li>Analitik ve performans iyileştirme</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              4. Bilgi Paylaşımı
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Kişisel verilerinizi aşağıdaki durumlar dışında üçüncü taraflarla paylaşmayız:
            </p>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Açık rızanızın bulunması</li>
              <li>Yasal zorunluluklar</li>
              <li>Hizmet sağlayıcılarımız (veri işleme sözleşmeleri ile)</li>
              <li>İş ortaklarımız (sadece gerekli bilgiler)</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              5. Veri Güvenliği
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Verilerinizi korumak için aşağıdaki güvenlik önlemlerini alırız:
            </p>
            <ul className="list-disc pl-6 text-gray-700">
              <li>SSL/TLS şifreleme</li>
              <li>Güvenli veri merkezleri</li>
              <li>Düzenli güvenlik denetimleri</li>
              <li>Erişim kontrolü ve yetkilendirme</li>
              <li>Veri yedekleme ve felaket kurtarma</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              6. Çerezler ve Benzer Teknolojiler
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Web sitemizde deneyiminizi iyileştirmek için çerezler kullanırız:
            </p>
            <ul className="list-disc pl-6 text-gray-700">
              <li><strong>Gerekli Çerezler:</strong> Temel işlevsellik için</li>
              <li><strong>Analitik Çerezler:</strong> Kullanım istatistikleri için</li>
              <li><strong>Pazarlama Çerezleri:</strong> Reklam ve promosyon için</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-4">
              Tarayıcı ayarlarınızdan çerezleri kontrol edebilirsiniz.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              7. Veri Saklama Süresi
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Kişisel verilerinizi, hizmet sağlama amacıyla gerekli olduğu sürece saklarız. 
              Hesabınızı kapattığınızda, verileriniz 30 gün içinde güvenli şekilde silinir. 
              Yasal yükümlülükler gereği saklanması gereken veriler daha uzun süre tutulabilir.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              8. Haklarınız
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              KVKK kapsamında aşağıdaki haklara sahipsiniz:
            </p>
            <ul className="list-disc pl-6 text-gray-700">
              <li>Kişisel verilerinize erişim</li>
              <li>Verilerinizin düzeltilmesi</li>
              <li>Verilerinizin silinmesi</li>
              <li>İşlemeye itiraz etme</li>
              <li>Veri taşınabilirliği</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              9. İletişim
            </h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              Gizlilik politikamız hakkında sorularınız için:
            </p>
            <div className="bg-gray-50 p-6 rounded-lg">
              <p className="text-gray-700">
                <strong>E-posta:</strong> info@cafeotomasyonu.com<br />
                <strong>Telefon:</strong> +90 507 588 04 81<br />
                <strong>Adres:</strong> Azmimilli Mahallesi. Şafak Sokak. No:37B. 81020, Merkez/DÜZCE
              </p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="font-poppins font-heading-bold text-2xl text-gray-900 mb-4">
              10. Değişiklikler
            </h2>
            <p className="text-gray-700 leading-relaxed">
              Bu Gizlilik Politikası zaman zaman güncellenebilir. Önemli değişiklikler 
              olduğunda sizi e-posta ile bilgilendiririz. Güncel politika her zaman 
              web sitemizde yayınlanır.
            </p>
          </section>
        </div>
      </main>
    </div>
  );
};

export default PrivacyPolicyPage; 